var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroup24(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 24"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 14",
    x: 0.5,
    y: 4.80005,
    width: 12,
    height: 2.4,
    fill: "url(#paint0_linear_536_290)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 15",
    x: 7.69922,
    width: 12,
    height: 2.4,
    transform: "rotate(90 7.69922 0)",
    fill: "url(#paint1_linear_536_290)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_536_290",
    x1: 0.5,
    y1: 6.00005,
    x2: 12.5,
    y2: 6.00005,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46F04E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ADE34D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_536_290",
    x1: 7.69922,
    y1: 1.2,
    x2: 19.6992,
    y2: 1.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46F04E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ADE34D"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup24);
export default __webpack_public_path__ + "static/media/Group 24.de5d934dff7bc932a92c735c96e6d92f.svg";
export { ForwardRef as ReactComponent };